import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../utils/api'
import { ListProgramsSpacesResponse } from '../../../types/swagger'
import createRequestSlice from '../../../utils/createRequestSlice'
import { ProgramSpace } from '../types'

export const getSpaceList = createAsyncThunk(
    'FETCH_TIMETABLE_ITEMS',
    async ({ eventSlug }: { eventSlug?: string }, thunkAPI) => {
        // @ts-ignore for some reason using selectEventSlug or RootState creates circular typing issues...
        const slug = eventSlug || thunkAPI.getState().event.current.data.slug
        const response = await api.get<ListProgramsSpacesResponse>(`/events/${slug}/virtualprogram/spaces/`)
        return response.results
    },
)

const timeTableSlice = createRequestSlice<ProgramSpace[]>(getSpaceList, 'timeTableSlice')

export default timeTableSlice.reducer
